import { Injectable, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { UtilitiesActions } from './utilities.actions';
import * as UtilitiesSelectors from './utilities.selectors';

@Injectable()
export class UtilitiesFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  inProgress$ = this.store.pipe(
    select(UtilitiesSelectors.selectUtilitiesInProgress),
  );

  queue() {
    this.store.dispatch(UtilitiesActions.progress());
  }
  complete() {
    this.store.dispatch(UtilitiesActions.complete());
  }
}
